import Link from 'next/link';

import { BlockErrorMessage } from '../../../Block/BlockErrorMessage';
import { ButtonBase } from '../../../Button/ButtonBase';
import { Select } from '../../../Form/Select';
import { InnerButtonAreaTwoColumns } from '../../../Layout/InnerLayout/InnerButtonAreaTwoColumns';
import { InnerMargin } from '../../../Layout/InnerLayout/InnerMargin';
import { TableBody } from '../../../Table/TableBody';
import { TableTrFormLabel } from '../../../Table/TableTr/TableTrFromLabel';

import type { LoggedInUser } from '../../../../types/LoggedInUser';
import type { AppEnv } from '@/packages/nurse-senka-frontend-sdk';
import type { FC, ChangeEventHandler, FormEventHandler } from 'react';

export type MailMagazineSettingContentsProps = {
  appEnv: AppEnv;
  loggedInUser: LoggedInUser;
  newsNotificationDefaultValue: 'receive' | 'notReceive';
  jobsNotificationDefaultValue: 'receive' | 'notReceive';
  disableSubmitButton?: boolean;
  errorMessage?: string;
  eventHandlers?: {
    changeNewsNotification: ChangeEventHandler<HTMLSelectElement>;
    changeJobsNotification: ChangeEventHandler<HTMLSelectElement>;
    submit: FormEventHandler<HTMLFormElement>;
  };
};

const mailMagazineAttributes = [
  {
    key: 1,
    value: 'receive',
    label: '受け取る',
  },
  {
    key: 2,
    value: 'notReceive',
    label: '受け取らない',
  },
];

// eslint-disable-next-line max-lines-per-function
export const MailMagazineSettingContents: FC<
  MailMagazineSettingContentsProps
> = ({
  disableSubmitButton,
  newsNotificationDefaultValue,
  jobsNotificationDefaultValue,
  errorMessage,
  eventHandlers,
}) => (
  <form method="post" onSubmit={eventHandlers?.submit}>
    <InnerMargin align="default">
      メルマガの受信可否を設定してください
    </InnerMargin>

    <TableBody>
      <TableTrFormLabel
        id="newsNotification"
        required={false}
        title="ナース専科の最新＆人気情報"
      >
        <Select
          id="news-notification"
          width="default"
          attributes={mailMagazineAttributes}
          onChange={eventHandlers?.changeNewsNotification}
          defaultValue={newsNotificationDefaultValue}
        />
      </TableTrFormLabel>
      <TableTrFormLabel
        id="jobsNotification"
        required={false}
        title="就職・転職情報"
      >
        <Select
          id="jobs-notification"
          width="default"
          attributes={mailMagazineAttributes}
          onChange={eventHandlers?.changeJobsNotification}
          defaultValue={jobsNotificationDefaultValue}
        />
      </TableTrFormLabel>
    </TableBody>

    {errorMessage ? <BlockErrorMessage>{errorMessage}</BlockErrorMessage> : ''}

    <InnerButtonAreaTwoColumns>
      <Link href="/" prefetch={false} legacyBehavior={true}>
        <ButtonBase color="secondary" width="wide">
          戻る
        </ButtonBase>
      </Link>
      <ButtonBase
        color="primary"
        width="wide"
        disable={disableSubmitButton === true}
      >
        変更内容を保存
      </ButtonBase>
    </InnerButtonAreaTwoColumns>
  </form>
);
